export default {
  title: 'Máscaras',
  name: 'Nombre',
  pattern: 'Máscara',
  enabled: 'Activado'
}
